import { combineReducers } from "redux"
import { RootState } from "../../../store"
import suggestionsByGameIdReducer from "./suggestionsByGameIdReducer"

export default combineReducers({
  suggestionsByGameId: suggestionsByGameIdReducer,
})
